import axios from "axios";
import API_BASE_URL from "../../../config/api";
import { useState, useEffect, useCallback } from "react";
import Addblog from "./addBlog/Addblog";
import "./blog.css";
import { Modal, Button } from "react-bootstrap";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editPost, setEditPost] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE_URL}/api/v1/blog`);
      setPosts(data || []);
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchPosts(); }, [fetchPosts]);

  const handleDelete = async (id) => {
    const token = localStorage.getItem("solochat.me");
    try {
      await axios.delete(`${API_BASE_URL}/api/v1/blog/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPosts((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error(err.message);
    }
    setDeleteTarget(null);
  };

  const handleEdit = (post) => {
    setEditPost(post);
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditPost(null);
    fetchPosts();
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditPost(null);
  };

  return (
    <div>
      {!showForm ? (
        <>
          <div className="blogHeader">
            <h3>Blog Posts</h3>
            <button className="blogCreateBtn" onClick={() => setShowForm(true)}>
              + New Post
            </button>
          </div>

          {loading && <div className="blogLoading">Loading...</div>}

          {!loading && posts.length === 0 && (
            <div className="blogEmpty">
              <img src="/empty-folder.png" alt="no posts" width="80" />
              <h4>No blog posts yet</h4>
              <p>Create your first blog post to share with your audience.</p>
              <button className="blogCreateBtn" onClick={() => setShowForm(true)}>
                + Create Your First Post
              </button>
            </div>
          )}

          {!loading && posts.length > 0 && (
            <div className="blogTable">
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Author</th>
                    <th>Date</th>
                    <th style={{ width: 160 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {posts.map((post) => (
                    <tr key={post.id}>
                      <td className="blogTitleCell">{post.title}</td>
                      <td>{post.author || "-"}</td>
                      <td>{new Date(post.created_at).toLocaleDateString()}</td>
                      <td>
                        <button
                          className="blogDeleteBtn"
                          style={{ marginRight: 6, color: "#3b82f6", borderColor: "#3b82f6" }}
                          onClick={() => handleEdit(post)}
                        >
                          Edit
                        </button>
                        <button
                          className="blogDeleteBtn"
                          onClick={() => setDeleteTarget(post.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : (
        <Addblog onSuccess={handleFormSuccess} onCancel={handleFormCancel} editPost={editPost} />
      )}

      <Modal show={!!deleteTarget} onHide={() => setDeleteTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this blog post?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteTarget(null)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleDelete(deleteTarget)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Blog;
